//
// locales/glitch/sr.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/sr';
import localeData from 'react-intl/locale-data/sr.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
